var DK = DK || {};
DK.socialMedia = DK.socialMedia || {};
DK.socialMedia = {
  init: function () {
    //Facebook
    (function () {
      let po = document.createElement('script');
      po.type = 'text/javascript';
      po.async = true;
      po.defer = true;
      po.src = '//connect.facebook.net/en_US/sdk.js#xfbml=1&appId=682407485432555&version=v2.11';
      po.id = 'facebook-jssdk';
      let s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(po, s);
    })();

    //Twitter
    (function () {
      let po = document.createElement('script');
      po.type = 'text/javascript';
      po.async = true;
      po.defer = true;
      po.src = 'https://platform.twitter.com/widgets.js';
      po.id = 'twitter-wjs';
      let s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(po, s);
    })();

    //Google Plus
    (function () {
      let po = document.createElement('script');
      po.type = 'text/javascript';
      po.async = true;
      po.src = 'https://apis.google.com/js/plusone.js?onload=onLoadCallback';
      let s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(po, s);
    })();

    //Pinterest
    (function () {
      let po = document.createElement('script');
      po.type = 'text/javascript';
      po.async = true;
      po.defer = true;
      po.src = 'https://assets.pinterest.com/js/pinit.js';
      let s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(po, s);
    })();
    $('a.facebook-bg').on('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      FB.ui({
        method: 'share',
        href: $('link[rel="canonical"]').attr('href')
      }, function (response) {});
    });
  }
};

//Copy url to clipboard function
function copyUrl() {
  let copyUrl = window.location.href;
  navigator.clipboard.writeText(copyUrl).then(() => {
    const popover = bootstrap.Popover.getInstance('#copy-url');
    setTimeout(function () {
      popover.hide();
    }, 2000);
  });
}
$(document).on('submit', '#send-to-friend-form', function (e) {
  e.preventDefault();
  const $form = $(this),
    spinner = new Spinner(),
    $modal = $form.parents('.modal'),
    $content = $modal.find('.modal-body-content');
  if ($content.length === 0) {
    // .modal-content will be empty on the standalone gift card
    // page. Target the form's parent element for the AJAX
    // spinner when the form is not in a modal.
    $content = $form.parent();
  }
  $.ajax({
    data: $form.serialize(),
    url: $form.attr('action'),
    method: $form.attr('method'),
    beforeSend: function () {
      DK.displayBlocker($content);
      spinner.spin($content.get()[0]);
    },
    complete: function () {
      DK.hideBlocker($content);
      spinner.stop();
    }
  }).done(function (data, textStatus, jqXHR) {
    $content.html(data);
  }).fail(function (jqXHR) {
    $form.html(jqXHR.responseText);
  });
});
$('.social-share-links').on('click', function () {
  DK.socialMedia.init();
});